import './themeDefaults';
import TYPES from './types';

export default ({ modal }) => ({
  hasHeader: {},
  hasSecondaryHeader: {},
  icon: {
    ...modal.icon,
    '&$hasHeader': {
      top: modal.icon.topWithHeader
    },
    '&$hasSecondaryHeader': {
      top: modal.icon.topWithSecondaryHeader
    }
  },
  [TYPES.ERROR]: {
    ...modal.errorModal
  },
  [TYPES.WARNING]: {
    ...modal.warningModal
  },
  [TYPES.SUCCESS]: {
    ...modal.successModal
  },
  [TYPES.INFO]: {
    ...modal.infoModal
  },
  header: {
    ...modal.header
  },
  primaryHeader: {
    ...modal.primaryHeader
  },
  secondaryHeader: {
    ...modal.secondaryHeader
  },
  secondaryHeaderDivider: {
    ...modal.secondaryHeaderDivider
  },
  btnClose: {
    ...modal.btnClose
  }
});
